/**
 * hasCalculate returns true/false whether a value has a _calculate property. Not recursive!
 * @param  {*} val
 * @returns  {Boolean}
 */
const hasCalculate = (val) => !!(val && !Array.isArray(val) && typeof val === 'object' && val._calculate);

export default hasCalculate;
